import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';

import titleMixin from './mixins/titleMixin'
import 'bootstrap/dist/css/bootstrap.css'
Vue.mixin(titleMixin)

Vue.use(VueTelInputVuetify, {
    vuetify,
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
